type DeferredPrompt = Event & {
  prompt: () => Promise<void>;
  userChoice?: Promise<{ outcome: "accepted" | "dismissed"; platform: string }>;
};

declare global {
  interface Window {
    __deferredPwaPrompt?: DeferredPrompt | null;
    __deferredPwaPromptInitialized?: boolean;
  }
}

export const initDeferredPwaPrompt = () => {
  if (typeof window === "undefined") return;
  if (window.__deferredPwaPromptInitialized) return;

  window.__deferredPwaPromptInitialized = true;
  window.__deferredPwaPrompt = null;

  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    window.__deferredPwaPrompt = e as DeferredPrompt;
  });

  window.addEventListener("appinstalled", () => {
    window.__deferredPwaPrompt = null;
  });
};

export const getDeferredPwaPrompt = () => {
  if (typeof window === "undefined") return null;
  return window.__deferredPwaPrompt ?? null;
};
